const couponTypes = {
  combine: "Combine",
  positionDrills: "PositionDrills",
  subscription: "Subscription",
  invalid: "Invalid",
  CombineAndPositionDrills: "CombineAndPositionDrills",
};
export default couponTypes;
